// Fix variant picker & sales point alignment after Swatch King injects HTML
function fixAlignment() {
  // Fix all variant picker containers
  document.querySelectorAll('.variant-input-wrap, fieldset.variant-input-wrap').forEach(function(el) {
    el.style.setProperty('display', 'flex', 'important');
    el.style.setProperty('flex-wrap', 'wrap', 'important');
    el.style.setProperty('justify-content', 'flex-start', 'important');
    el.style.setProperty('align-items', 'center', 'important');
    el.style.setProperty('gap', '8px', 'important');
    el.style.setProperty('border', 'none', 'important');
    el.style.setProperty('padding', '0', 'important');
    el.style.setProperty('margin', '0', 'important');
  });

  // Fix Swatch King containers (try multiple possible class names)
  document.querySelectorAll('[class*="swatch"], [class*="sk-"], [data-swatch-king]').forEach(function(el) {
    var parent = el.closest('.product-block, .variant-wrapper');
    if (parent) {
      el.style.setProperty('display', 'flex', 'important');
      el.style.setProperty('flex-wrap', 'wrap', 'important');
      el.style.setProperty('justify-content', 'flex-start', 'important');
      el.style.setProperty('text-align', 'left', 'important');
    }
  });

  // Fix variant labels
  document.querySelectorAll('.variant__label').forEach(function(el) {
    el.style.setProperty('display', 'block', 'important');
    el.style.setProperty('text-align', 'left', 'important');
    el.style.setProperty('width', '100%', 'important');
  });

  // Fix sales points icon-and-text
  document.querySelectorAll('.icon-and-text').forEach(function(el) {
    el.style.setProperty('display', 'flex', 'important');
    el.style.setProperty('flex-direction', 'row', 'important');
    el.style.setProperty('align-items', 'center', 'important');
    el.style.setProperty('justify-content', 'flex-start', 'important');
    el.style.setProperty('gap', '10px', 'important');
    el.style.setProperty('text-align', 'left', 'important');
  });

  // Fix individual variant inputs
  document.querySelectorAll('.variant-input').forEach(function(el) {
    el.style.setProperty('float', 'none', 'important');
    el.style.setProperty('display', 'inline-block', 'important');
    el.style.setProperty('margin', '0', 'important');
  });
}

// Run immediately
fixAlignment();

// Run after DOM loaded
document.addEventListener('DOMContentLoaded', fixAlignment);

// Run after everything loaded (including Swatch King)
window.addEventListener('load', fixAlignment);

// Run after a delay to catch late-loading apps
setTimeout(fixAlignment, 500);
setTimeout(fixAlignment, 1000);
setTimeout(fixAlignment, 2000);

// Watch for DOM changes (catches Swatch King dynamic injection)
if (window.MutationObserver) {
  var observer = new MutationObserver(function(mutations) {
    var relevant = mutations.some(function(m) {
      return m.addedNodes.length > 0;
    });
    if (relevant) fixAlignment();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
